export const enum CheckoutSteps {
  PERSONAL_DATA = 'PERSONAL_DATA',
  PAYMENT = 'PAYMENT',
  PHONE_VALIDATION = 'PHONE_VALIDATION',
}
